import * as Api from "../../Api";

import { actionCreator, asyncActionCreators } from "../../lib/util/ReduxUtils";

import * as StorageUtils from "../../lib/util/StorageUtils";
import { OVERRIDE_PROGRAM_KEY } from "../../StorageKeys";

export const getProgramData = asyncActionCreators<{ programId: string }, any>(
	"[PROGRAM] GET_PROGRAM_DATA",
	async (action, dispatch, getState) => {
		const { programId } = action.payload;
		return Api.fetchProgram.submit({
			params: { programId: programId },
			options: {
				lock: "user_current_program",
			},
		});
	},
);

export const setProgram = actionCreator<string>(
	"[PROGRAM] SET_PROGRAM",
	(action, dispatch) => {
		const programId = action.payload;
		if (programId) {
			dispatch(getProgramData({ programId }));
		}
		StorageUtils.set(OVERRIDE_PROGRAM_KEY, programId);
		return action;
	},
);
